import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Sparkles } from "lucide-react";
import { BRAND } from "@/lib/api";

const links = [
  { to: "/#meet-jesse", label: "Meet Jesse" },
  { to: "/#faith", label: "Faith" },
  { to: "/#services", label: "Services" },
  { to: "/#areas", label: "Areas" },
  { to: "/#locations", label: "Locations" },
  { to: "/blog", label: "Blog" },
  { to: "/#enquiry", label: "Enquire" },
];

function openWellbeing() {
  window.dispatchEvent(new Event("open-wellbeing"));
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 bg-cream/90 backdrop-blur-md border-b border-sand/50"
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-10 flex items-center justify-between gap-6 py-5 md:py-6">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-4 group flex-shrink-0"
        >
          <img
            src={BRAND.logoUrl}
            alt="A Mindful Space Counselling"
            className="h-24 w-24 md:h-[140px] md:w-[140px] rounded-full object-cover transition-transform duration-500 group-hover:rotate-6"
          />
          <div className="leading-tight hidden 2xl:block">
            <div className="font-serif text-2xl text-ink tracking-tight whitespace-nowrap">
              A Mindful Space Counselling
            </div>
            <div className="font-serif italic text-base text-ink-muted mt-1 tracking-wide">
              Tasmania
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-7 lg:gap-9 flex-shrink-0">
          {links.map((l) => {
            const isAnchor = l.to.includes("#");
            if (isAnchor && onHome) {
              return (
                <a
                  key={l.to}
                  href={l.to.replace("/", "")}
                  data-testid={`nav-link-${l.label.toLowerCase()}`}
                  className="text-base text-ink hover:text-navy transition-colors relative after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-navy hover:after:w-full after:transition-all after:duration-300"
                >
                  {l.label}
                </a>
              );
            }
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-base text-ink hover:text-navy transition-colors"
              >
                {l.label}
              </Link>
            );
          })}
          <button
            type="button"
            onClick={openWellbeing}
            data-testid="nav-wellbeing-check"
            className="inline-flex items-center gap-1.5 rounded-full bg-sage/15 text-sage-deep px-4 py-2 text-sm font-medium border border-sage/40 hover:bg-sage/25 hover:-translate-y-0.5 transition-all duration-300 whitespace-nowrap"
          >
            <Sparkles size={13} /> Wellbeing Check
          </button>
          <Link
            to="/book"
            data-testid="nav-book-button"
            className="inline-flex items-center gap-2 rounded-full bg-navy text-cream px-7 py-3 text-base font-medium hover:bg-navy-deep hover:-translate-y-0.5 shadow-[0_10px_24px_-10px_rgba(14,59,74,0.7)] transition-all duration-300 whitespace-nowrap"
          >
            Book a Session
          </Link>
        </nav>

        <button
          className="md:hidden text-ink p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="nav-menu-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-sand/50 bg-cream-soft">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => {
              const isAnchor = l.to.includes("#");
              if (isAnchor && onHome) {
                return (
                  <a
                    key={l.to}
                    href={l.to.replace("/", "")}
                    onClick={() => setOpen(false)}
                    className="py-2 text-ink-muted hover:text-teal"
                  >
                    {l.label}
                  </a>
                );
              }
              return (
                <Link
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="py-2 text-ink-muted hover:text-teal"
                >
                  {l.label}
                </Link>
              );
            })}
            <button
              type="button"
              onClick={() => { setOpen(false); openWellbeing(); }}
              data-testid="nav-wellbeing-check-mobile"
              className="mt-1 inline-flex items-center justify-center gap-2 rounded-full bg-sage/15 text-sage-deep border border-sage/40 px-5 py-3 text-sm font-medium"
            >
              <Sparkles size={14} /> Wellbeing Check
            </button>
            <Link
              to="/book"
              onClick={() => setOpen(false)}
              className="mt-2 text-center rounded-full bg-navy text-cream px-5 py-3 text-sm font-medium"
            >
              Book a Session
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
